
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexj5XbFI6UZkzHCfhzQC4OHTl_fKjKj45CvgINbiS9f3AMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue?macro=true";
import { default as indexE_udtWpWzN1EPRdeoo8Y4SXBiKOnF52igWYF5W0nXL8Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue?macro=true";
import { default as indexAXQEfEx7e7mcUSxx_45Um24t2l4pY0QT8hCSMaLvvGpKkMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue?macro=true";
import { default as indexEGjlYubxMWOu8p7YKuk9JnhpK4_NKOEsEoYyyr3E4swMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue?macro=true";
import { default as indexnV0cAaPQZ0z_Df64h8SEmWef0fCZlmQhyMPjlBOpAbIMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue?macro=true";
import { default as indexWFnbIY7SDNBv0EC3p0Tw_tOT8ggZ_45hP851U7JOCBmX0Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue?macro=true";
import { default as indexy7OZP_45rOnOZWqf4RvSeIeQKrjg6r6oVVkc9aI8OQ3fAMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue?macro=true";
import { default as indexarQI_45ZjrbAf6HgE1hjbWY1dvcrYj68k7vH_45pFpHmdMEMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue?macro=true";
import { default as indexjTuLiz1kT1FH7DuPEQTI2pNHx4sBWm44f3nqL14pm_45MMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue?macro=true";
import { default as indexIiMwHCNNlELCMVt14fEJwUmWt2ZGegWUOg8UWbAJUacMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue?macro=true";
import { default as indexImUpGhAon_ihagf_45fFgcw9D6gLA8VrVySl7k1Nt4Nw8Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue?macro=true";
import { default as indexu_458nWj5j3EMgPdJG6XuofIX9isrcXVl21k5XNUCZhp8Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue?macro=true";
import { default as index_Vk0tk07I7HVJm9sJC6vqT4KSa3KZ_mSxJeacL2xfBkMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue?macro=true";
import { default as indexesfv8CefxhDWQqg7uoCNuqgGb_dLSMRrmo0Zd9db7mIMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue?macro=true";
import { default as index2n8nqcqB_45x6QfZyRWHC6jad_2eQAdeTx5Ph9S4OJXgQMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue?macro=true";
import { default as indexgH_c6lR6qzTy7FZDCOkECWmBXIlMLKYzN6e9FTOqAgYMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue?macro=true";
import { default as index_45uacsvN_xgEJVRsxa7R1eWH1nXdkaOjU1Rya8lLLcZ0Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue?macro=true";
import { default as indexDfcSX2J3BzMj0X_45V2LdWrugsEgYkNYSpjAQWRHeQGtUMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue?macro=true";
import { default as indexWxqv9JhGNkoTBGRyDT2uxUeZmey_USO3_iYn7Adss0gMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue?macro=true";
import { default as indexyIu6_45vuIWxbAeDj93BsZ8fHb8yR4lzN2H_8piYXcFv8Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue?macro=true";
import { default as indexDYNwK6OeHTdqlY6FZi6PIBQUjvaDNGthTlBf3HwxebsMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue?macro=true";
import { default as indexNIoAhJkykIA8AixKu53GpXIZ_45mhZaM_45VnEKvgtZRZL8Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue?macro=true";
import { default as index95uPQiC_lRo684pAUTrXDIlam5dgMetdCOUgBsSyScgMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue?macro=true";
import { default as indexv1YhcxePBNkgT2qj9tRnl_45B1CHo_O8G_LO9oXx5UtAUMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue?macro=true";
import { default as indexGhoFaHUQzfhek18KHDWJvctlWs0vDKdf_45KhWBiVxm6cMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue?macro=true";
import { default as index8iQGO_45IbCsqTPAv8WtjpQP0zm1hsbKwDvL32OvmL6icMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue?macro=true";
import { default as indexokecPMs2S2zWSWW03vWaFvV6V17ygP_45KtPLCnWyI0XcMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue?macro=true";
import { default as indexq6MOg_45kU4lgguyfVtULodbZvLk_45GdxerCLxQdMFJUA0Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue?macro=true";
import { default as indexFLevbzmCypFdsN4dSKurnYNuoY1WyfjyKBsBLGYeMzoMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue?macro=true";
import { default as index4IQh6MSVcC5lyIg48WU6qZfGUV9Yhf_F6oFc6OQDsK0Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue?macro=true";
import { default as indexkC8qfoRQlSvxG5yslkI69jbM_6DqGUZx94IUbBl_q74Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue?macro=true";
import { default as indexowS8zkZb0CVOvMWmuLZj_45wbubh_454WAIpxFsDo0ZKVmUMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue?macro=true";
import { default as indexO_mWqn1GnS1Bq4EeW2qsQRP2LQ2Omng2pdPDCRtmtMAMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue?macro=true";
import { default as indexvxz4HTh9egeh_45JojfbOj779yL43e3AZ707dtf1dfdjEMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue?macro=true";
import { default as indexDilj_dAz9PlACIMgcICurUkG7xCun7O5nKZfSW5XD30Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue?macro=true";
import { default as indexthNQcI1D4GLuFdBmZJAW3qHsd9jS83dfRlsxJrBcy7UMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue?macro=true";
import { default as indexvcpfbimV7btJqkS7p2DlVbUDM3LvD3YPrGGykO9p9lEMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue?macro=true";
import { default as indexwbWZV98qXRgvjRhdJlXXUX6AJrcBNQGyT5U9psOB1SAMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue?macro=true";
import { default as indexPo3MK_45LYmIF4zkoHsjrrGQzmziLrZjnuRlQes_3PjxkMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue?macro=true";
import { default as indexF8cLHSLuqeRcpEbZ5NW_xcy6wgDSNRgTscQt2gZC4ukMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue?macro=true";
import { default as indexS_b9cso5WYQaR5dyZi6w5Ncd6XkEawVdr_457gi3eg8n0Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue?macro=true";
import { default as indexBy1mnfuUyh1t3TGFAgFqV5VVIv7QWQdr1rLHssk0rq4Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue?macro=true";
import { default as indexvBXgtxeKNvs_453XXizfGWfkavlImH2UubxxQQn7vlBgMMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue?macro=true";
import { default as index6TV9h8zV9jI_45PQch35BE_vFPQkVq52E1nH74eV9DPFkMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue?macro=true";
import { default as index_W7o7BsW1j7O73wO_GA4tmjguQNieJqtIZt_PhWY6msMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue?macro=true";
import { default as index_VU_h__rbSs3zNa1713DLEq0iAxZiBYce0NPNXGeCaAMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue?macro=true";
import { default as indexE8YTsPlW2pWCx9gnEt_456PhK1g0atH92B49aDpuS7SbUMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue?macro=true";
import { default as indexdfyoqfGFZEuoRjpLEkT3h8wCrwIILGQgn5czHpkkeIMMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue?macro=true";
import { default as indexbMlrEurGYWUKFD2OLdGT7TNWhFlPcawdJ1ONb9h6pnsMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue?macro=true";
import { default as indexJZpulWXvqX626SOO7QSZpb8gs2Zq1QmTXgGEyywF_LIMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue?macro=true";
import { default as index6O8DfccPNL287VgSt3FJEO_45hF5lMUgY44PrLDeMbElIMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue?macro=true";
import { default as index_45E58XV6x9frGgCmJEtqSTwekyVU1egBJ7qAzjZl6YfoMeta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue?macro=true";
import { default as component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64 } from "/codebuild/output/src3564164168/src/TVEUROPE-landing/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/index.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue")
  },
  {
    name: "faq___it",
    path: "/it/faq/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue")
  },
  {
    name: "faq___fr",
    path: "/fr/faq/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue")
  },
  {
    name: "faq___pt",
    path: "/pt/faq/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue")
  },
  {
    name: "faq___pl",
    path: "/pl/faq/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/index.vue")
  },
  {
    name: "trading___en",
    path: "/en/trading/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue")
  },
  {
    name: "trading___es",
    path: "/es/trading/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue")
  },
  {
    name: "trading___it",
    path: "/it/trading/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue")
  },
  {
    name: "trading___fr",
    path: "/fr/trading/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue")
  },
  {
    name: "trading___pt",
    path: "/pt/trading/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue")
  },
  {
    name: "trading___pl",
    path: "/pl/trading/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/index.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___es",
    path: "/es/contact-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___it",
    path: "/it/contact-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___fr",
    path: "/fr/contact-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___pt",
    path: "/pt/contact-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___pl",
    path: "/pl/contact-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/contact-us/index.vue")
  },
  {
    name: "trading-markets___en",
    path: "/en/trading/markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue")
  },
  {
    name: "trading-markets___es",
    path: "/es/trading/markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue")
  },
  {
    name: "trading-markets___it",
    path: "/it/trading/markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue")
  },
  {
    name: "trading-markets___fr",
    path: "/fr/trading/markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue")
  },
  {
    name: "trading-markets___pt",
    path: "/pt/trading/markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue")
  },
  {
    name: "trading-markets___pl",
    path: "/pl/trading/markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/index.vue")
  },
  {
    name: "company-about-us___en",
    path: "/en/company/about-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue")
  },
  {
    name: "company-about-us___es",
    path: "/es/company/about-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue")
  },
  {
    name: "company-about-us___it",
    path: "/it/company/about-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue")
  },
  {
    name: "company-about-us___fr",
    path: "/fr/company/about-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue")
  },
  {
    name: "company-about-us___pt",
    path: "/pt/company/about-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue")
  },
  {
    name: "company-about-us___pl",
    path: "/pl/company/about-us/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/about-us/index.vue")
  },
  {
    name: "trading-accounts___en",
    path: "/en/trading/accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue")
  },
  {
    name: "trading-accounts___es",
    path: "/es/trading/accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue")
  },
  {
    name: "trading-accounts___it",
    path: "/it/trading/accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue")
  },
  {
    name: "trading-accounts___fr",
    path: "/fr/trading/accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue")
  },
  {
    name: "trading-accounts___pt",
    path: "/pt/trading/accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue")
  },
  {
    name: "trading-accounts___pl",
    path: "/pl/trading/accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/accounts/index.vue")
  },
  {
    name: "trading-platforms___en",
    path: "/en/trading/platforms/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue")
  },
  {
    name: "trading-platforms___es",
    path: "/es/trading/platforms/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue")
  },
  {
    name: "trading-platforms___it",
    path: "/it/trading/platforms/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue")
  },
  {
    name: "trading-platforms___fr",
    path: "/fr/trading/platforms/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue")
  },
  {
    name: "trading-platforms___pt",
    path: "/pt/trading/platforms/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue")
  },
  {
    name: "trading-platforms___pl",
    path: "/pl/trading/platforms/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/index.vue")
  },
  {
    name: "company-regulation___en",
    path: "/en/company/regulation/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue")
  },
  {
    name: "company-regulation___es",
    path: "/es/company/regulation/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue")
  },
  {
    name: "company-regulation___it",
    path: "/it/company/regulation/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue")
  },
  {
    name: "company-regulation___fr",
    path: "/fr/company/regulation/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue")
  },
  {
    name: "company-regulation___pt",
    path: "/pt/company/regulation/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue")
  },
  {
    name: "company-regulation___pl",
    path: "/pl/company/regulation/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/company/regulation/index.vue")
  },
  {
    name: "forms-and-documents___en",
    path: "/en/forms-and-documents/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue")
  },
  {
    name: "forms-and-documents___es",
    path: "/es/forms-and-documents/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue")
  },
  {
    name: "forms-and-documents___it",
    path: "/it/forms-and-documents/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue")
  },
  {
    name: "forms-and-documents___fr",
    path: "/fr/forms-and-documents/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue")
  },
  {
    name: "forms-and-documents___pt",
    path: "/pt/forms-and-documents/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue")
  },
  {
    name: "forms-and-documents___pl",
    path: "/pl/forms-and-documents/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/forms-and-documents/index.vue")
  },
  {
    name: "trading-markets-forex___en",
    path: "/en/trading/markets/forex/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue")
  },
  {
    name: "trading-markets-forex___es",
    path: "/es/trading/markets/forex/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue")
  },
  {
    name: "trading-markets-forex___it",
    path: "/it/trading/markets/forex/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue")
  },
  {
    name: "trading-markets-forex___fr",
    path: "/fr/trading/markets/forex/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue")
  },
  {
    name: "trading-markets-forex___pt",
    path: "/pt/trading/markets/forex/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue")
  },
  {
    name: "trading-markets-forex___pl",
    path: "/pl/trading/markets/forex/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/forex/index.vue")
  },
  {
    name: "trading-markets-stocks___en",
    path: "/en/trading/markets/stocks/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue")
  },
  {
    name: "trading-markets-stocks___es",
    path: "/es/trading/markets/stocks/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue")
  },
  {
    name: "trading-markets-stocks___it",
    path: "/it/trading/markets/stocks/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue")
  },
  {
    name: "trading-markets-stocks___fr",
    path: "/fr/trading/markets/stocks/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue")
  },
  {
    name: "trading-markets-stocks___pt",
    path: "/pt/trading/markets/stocks/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue")
  },
  {
    name: "trading-markets-stocks___pl",
    path: "/pl/trading/markets/stocks/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/stocks/index.vue")
  },
  {
    name: "trading-markets-indices___en",
    path: "/en/trading/markets/indices/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue")
  },
  {
    name: "trading-markets-indices___es",
    path: "/es/trading/markets/indices/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue")
  },
  {
    name: "trading-markets-indices___it",
    path: "/it/trading/markets/indices/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue")
  },
  {
    name: "trading-markets-indices___fr",
    path: "/fr/trading/markets/indices/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue")
  },
  {
    name: "trading-markets-indices___pt",
    path: "/pt/trading/markets/indices/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue")
  },
  {
    name: "trading-markets-indices___pl",
    path: "/pl/trading/markets/indices/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/indices/index.vue")
  },
  {
    name: "trading-calculator_suite___en",
    path: "/en/trading/calculator_suite/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue")
  },
  {
    name: "trading-calculator_suite___es",
    path: "/es/trading/calculator_suite/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue")
  },
  {
    name: "trading-calculator_suite___it",
    path: "/it/trading/calculator_suite/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue")
  },
  {
    name: "trading-calculator_suite___fr",
    path: "/fr/trading/calculator_suite/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue")
  },
  {
    name: "trading-calculator_suite___pt",
    path: "/pt/trading/calculator_suite/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue")
  },
  {
    name: "trading-calculator_suite___pl",
    path: "/pl/trading/calculator_suite/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/calculator_suite/index.vue")
  },
  {
    name: "trading-markets-commodities___en",
    path: "/en/trading/markets/commodities/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue")
  },
  {
    name: "trading-markets-commodities___es",
    path: "/es/trading/markets/commodities/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue")
  },
  {
    name: "trading-markets-commodities___it",
    path: "/it/trading/markets/commodities/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue")
  },
  {
    name: "trading-markets-commodities___fr",
    path: "/fr/trading/markets/commodities/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue")
  },
  {
    name: "trading-markets-commodities___pt",
    path: "/pt/trading/markets/commodities/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue")
  },
  {
    name: "trading-markets-commodities___pl",
    path: "/pl/trading/markets/commodities/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/commodities/index.vue")
  },
  {
    name: "trading-platforms-metatrader5___en",
    path: "/en/trading/platforms/metatrader5/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue")
  },
  {
    name: "trading-platforms-metatrader5___es",
    path: "/es/trading/platforms/metatrader5/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue")
  },
  {
    name: "trading-platforms-metatrader5___it",
    path: "/it/trading/platforms/metatrader5/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue")
  },
  {
    name: "trading-platforms-metatrader5___fr",
    path: "/fr/trading/platforms/metatrader5/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue")
  },
  {
    name: "trading-platforms-metatrader5___pt",
    path: "/pt/trading/platforms/metatrader5/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue")
  },
  {
    name: "trading-platforms-metatrader5___pl",
    path: "/pl/trading/platforms/metatrader5/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/platforms/metatrader5/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-fund-my-account___en",
    path: "/en/faq/manage-my-account/how-do-i-fund-my-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-fund-my-account___es",
    path: "/es/faq/manage-my-account/how-do-i-fund-my-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-fund-my-account___it",
    path: "/it/faq/manage-my-account/how-do-i-fund-my-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-fund-my-account___fr",
    path: "/fr/faq/manage-my-account/how-do-i-fund-my-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-fund-my-account___pt",
    path: "/pt/faq/manage-my-account/how-do-i-fund-my-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-fund-my-account___pl",
    path: "/pl/faq/manage-my-account/how-do-i-fund-my-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-fund-my-account/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-order-types___en",
    path: "/en/trading/markets/trading-conditions/order-types/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-order-types___es",
    path: "/es/trading/markets/trading-conditions/order-types/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-order-types___it",
    path: "/it/trading/markets/trading-conditions/order-types/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-order-types___fr",
    path: "/fr/trading/markets/trading-conditions/order-types/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-order-types___pt",
    path: "/pt/trading/markets/trading-conditions/order-types/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-order-types___pl",
    path: "/pl/trading/markets/trading-conditions/order-types/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/order-types/index.vue")
  },
  {
    name: "faq-new-user-guide-where-can-i-manage-my-accounts___en",
    path: "/en/faq/new-user-guide/where-can-i-manage-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue")
  },
  {
    name: "faq-new-user-guide-where-can-i-manage-my-accounts___es",
    path: "/es/faq/new-user-guide/where-can-i-manage-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue")
  },
  {
    name: "faq-new-user-guide-where-can-i-manage-my-accounts___it",
    path: "/it/faq/new-user-guide/where-can-i-manage-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue")
  },
  {
    name: "faq-new-user-guide-where-can-i-manage-my-accounts___fr",
    path: "/fr/faq/new-user-guide/where-can-i-manage-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue")
  },
  {
    name: "faq-new-user-guide-where-can-i-manage-my-accounts___pt",
    path: "/pt/faq/new-user-guide/where-can-i-manage-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue")
  },
  {
    name: "faq-new-user-guide-where-can-i-manage-my-accounts___pl",
    path: "/pl/faq/new-user-guide/where-can-i-manage-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/where-can-i-manage-my-accounts/index.vue")
  },
  {
    name: "faq-account-features-do-you-offer-direct-liquidity___en",
    path: "/en/faq/account-features/do-you-offer-direct-liquidity/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue")
  },
  {
    name: "faq-account-features-do-you-offer-direct-liquidity___es",
    path: "/es/faq/account-features/do-you-offer-direct-liquidity/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue")
  },
  {
    name: "faq-account-features-do-you-offer-direct-liquidity___it",
    path: "/it/faq/account-features/do-you-offer-direct-liquidity/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue")
  },
  {
    name: "faq-account-features-do-you-offer-direct-liquidity___fr",
    path: "/fr/faq/account-features/do-you-offer-direct-liquidity/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue")
  },
  {
    name: "faq-account-features-do-you-offer-direct-liquidity___pt",
    path: "/pt/faq/account-features/do-you-offer-direct-liquidity/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue")
  },
  {
    name: "faq-account-features-do-you-offer-direct-liquidity___pl",
    path: "/pl/faq/account-features/do-you-offer-direct-liquidity/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/do-you-offer-direct-liquidity/index.vue")
  },
  {
    name: "faq-privacy-and-security-is-tradeview-markets-regulated___en",
    path: "/en/faq/privacy-and-security/is-tradeview-markets-regulated/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue")
  },
  {
    name: "faq-privacy-and-security-is-tradeview-markets-regulated___es",
    path: "/es/faq/privacy-and-security/is-tradeview-markets-regulated/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue")
  },
  {
    name: "faq-privacy-and-security-is-tradeview-markets-regulated___it",
    path: "/it/faq/privacy-and-security/is-tradeview-markets-regulated/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue")
  },
  {
    name: "faq-privacy-and-security-is-tradeview-markets-regulated___fr",
    path: "/fr/faq/privacy-and-security/is-tradeview-markets-regulated/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue")
  },
  {
    name: "faq-privacy-and-security-is-tradeview-markets-regulated___pt",
    path: "/pt/faq/privacy-and-security/is-tradeview-markets-regulated/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue")
  },
  {
    name: "faq-privacy-and-security-is-tradeview-markets-regulated___pl",
    path: "/pl/faq/privacy-and-security/is-tradeview-markets-regulated/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/is-tradeview-markets-regulated/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-contract-specs___en",
    path: "/en/trading/markets/trading-conditions/forex-contract-specs/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-contract-specs___es",
    path: "/es/trading/markets/trading-conditions/forex-contract-specs/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-contract-specs___it",
    path: "/it/trading/markets/trading-conditions/forex-contract-specs/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-contract-specs___fr",
    path: "/fr/trading/markets/trading-conditions/forex-contract-specs/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-contract-specs___pt",
    path: "/pt/trading/markets/trading-conditions/forex-contract-specs/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-contract-specs___pl",
    path: "/pl/trading/markets/trading-conditions/forex-contract-specs/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-contract-specs/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-rollover-rates___en",
    path: "/en/trading/markets/trading-conditions/forex-rollover-rates/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-rollover-rates___es",
    path: "/es/trading/markets/trading-conditions/forex-rollover-rates/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-rollover-rates___it",
    path: "/it/trading/markets/trading-conditions/forex-rollover-rates/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-rollover-rates___fr",
    path: "/fr/trading/markets/trading-conditions/forex-rollover-rates/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-rollover-rates___pt",
    path: "/pt/trading/markets/trading-conditions/forex-rollover-rates/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-rollover-rates___pl",
    path: "/pl/trading/markets/trading-conditions/forex-rollover-rates/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-rollover-rates/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-stocks-trading-hours___en",
    path: "/en/trading/markets/trading-conditions/stocks-trading-hours/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-stocks-trading-hours___es",
    path: "/es/trading/markets/trading-conditions/stocks-trading-hours/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-stocks-trading-hours___it",
    path: "/it/trading/markets/trading-conditions/stocks-trading-hours/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-stocks-trading-hours___fr",
    path: "/fr/trading/markets/trading-conditions/stocks-trading-hours/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-stocks-trading-hours___pt",
    path: "/pt/trading/markets/trading-conditions/stocks-trading-hours/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-stocks-trading-hours___pl",
    path: "/pl/trading/markets/trading-conditions/stocks-trading-hours/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/stocks-trading-hours/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-deposit-in-multiple-currencies___en",
    path: "/en/faq/manage-my-account/can-i-deposit-in-multiple-currencies/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-deposit-in-multiple-currencies___es",
    path: "/es/faq/manage-my-account/can-i-deposit-in-multiple-currencies/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-deposit-in-multiple-currencies___it",
    path: "/it/faq/manage-my-account/can-i-deposit-in-multiple-currencies/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-deposit-in-multiple-currencies___fr",
    path: "/fr/faq/manage-my-account/can-i-deposit-in-multiple-currencies/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-deposit-in-multiple-currencies___pt",
    path: "/pt/faq/manage-my-account/can-i-deposit-in-multiple-currencies/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-deposit-in-multiple-currencies___pl",
    path: "/pl/faq/manage-my-account/can-i-deposit-in-multiple-currencies/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-deposit-in-multiple-currencies/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-trade-on-the-go-with-a-mobile-app___en",
    path: "/en/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-trade-on-the-go-with-a-mobile-app___es",
    path: "/es/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-trade-on-the-go-with-a-mobile-app___it",
    path: "/it/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-trade-on-the-go-with-a-mobile-app___fr",
    path: "/fr/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-trade-on-the-go-with-a-mobile-app___pt",
    path: "/pt/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-trade-on-the-go-with-a-mobile-app___pl",
    path: "/pl/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-trade-on-the-go-with-a-mobile-app/index.vue")
  },
  {
    name: "faq-new-user-guide-does-tradeview-offer-fix-api-technology___en",
    path: "/en/faq/new-user-guide/does-tradeview-offer-fix-api-technology/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue")
  },
  {
    name: "faq-new-user-guide-does-tradeview-offer-fix-api-technology___es",
    path: "/es/faq/new-user-guide/does-tradeview-offer-fix-api-technology/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue")
  },
  {
    name: "faq-new-user-guide-does-tradeview-offer-fix-api-technology___it",
    path: "/it/faq/new-user-guide/does-tradeview-offer-fix-api-technology/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue")
  },
  {
    name: "faq-new-user-guide-does-tradeview-offer-fix-api-technology___fr",
    path: "/fr/faq/new-user-guide/does-tradeview-offer-fix-api-technology/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue")
  },
  {
    name: "faq-new-user-guide-does-tradeview-offer-fix-api-technology___pt",
    path: "/pt/faq/new-user-guide/does-tradeview-offer-fix-api-technology/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue")
  },
  {
    name: "faq-new-user-guide-does-tradeview-offer-fix-api-technology___pl",
    path: "/pl/faq/new-user-guide/does-tradeview-offer-fix-api-technology/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/does-tradeview-offer-fix-api-technology/index.vue")
  },
  {
    name: "faq-new-user-guide-when-can-i-trade-with-tradeview-markets___en",
    path: "/en/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-when-can-i-trade-with-tradeview-markets___es",
    path: "/es/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-when-can-i-trade-with-tradeview-markets___it",
    path: "/it/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-when-can-i-trade-with-tradeview-markets___fr",
    path: "/fr/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-when-can-i-trade-with-tradeview-markets___pt",
    path: "/pt/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-when-can-i-trade-with-tradeview-markets___pl",
    path: "/pl/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/when-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-economic-calendar___en",
    path: "/en/trading/markets/trading-conditions/forex-economic-calendar/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-economic-calendar___es",
    path: "/es/trading/markets/trading-conditions/forex-economic-calendar/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-economic-calendar___it",
    path: "/it/trading/markets/trading-conditions/forex-economic-calendar/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-economic-calendar___fr",
    path: "/fr/trading/markets/trading-conditions/forex-economic-calendar/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-economic-calendar___pt",
    path: "/pt/trading/markets/trading-conditions/forex-economic-calendar/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-forex-economic-calendar___pl",
    path: "/pl/trading/markets/trading-conditions/forex-economic-calendar/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/forex-economic-calendar/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay___en",
    path: "/en/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay___es",
    path: "/es/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay___it",
    path: "/it/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay___fr",
    path: "/fr/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay___pt",
    path: "/pt/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay___pl",
    path: "/pl/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-trading-conditions-events___en",
    path: "/en/trading/markets/trading-conditions/trading-conditions-events/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-trading-conditions-events___es",
    path: "/es/trading/markets/trading-conditions/trading-conditions-events/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-trading-conditions-events___it",
    path: "/it/trading/markets/trading-conditions/trading-conditions-events/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-trading-conditions-events___fr",
    path: "/fr/trading/markets/trading-conditions/trading-conditions-events/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-trading-conditions-events___pt",
    path: "/pt/trading/markets/trading-conditions/trading-conditions-events/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue")
  },
  {
    name: "trading-markets-trading-conditions-trading-conditions-events___pl",
    path: "/pl/trading/markets/trading-conditions/trading-conditions-events/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/trading/markets/trading-conditions/trading-conditions-events/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-transfer-funds-between-my-accounts___en",
    path: "/en/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-transfer-funds-between-my-accounts___es",
    path: "/es/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-transfer-funds-between-my-accounts___it",
    path: "/it/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-transfer-funds-between-my-accounts___fr",
    path: "/fr/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-transfer-funds-between-my-accounts___pt",
    path: "/pt/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-transfer-funds-between-my-accounts___pl",
    path: "/pl/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-transfer-funds-between-my-accounts/index.vue")
  },
  {
    name: "faq-new-user-guide-common-issues-in-the-id-verification-process___en",
    path: "/en/faq/new-user-guide/common-issues-in-the-id-verification-process/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue")
  },
  {
    name: "faq-new-user-guide-common-issues-in-the-id-verification-process___es",
    path: "/es/faq/new-user-guide/common-issues-in-the-id-verification-process/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue")
  },
  {
    name: "faq-new-user-guide-common-issues-in-the-id-verification-process___it",
    path: "/it/faq/new-user-guide/common-issues-in-the-id-verification-process/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue")
  },
  {
    name: "faq-new-user-guide-common-issues-in-the-id-verification-process___fr",
    path: "/fr/faq/new-user-guide/common-issues-in-the-id-verification-process/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue")
  },
  {
    name: "faq-new-user-guide-common-issues-in-the-id-verification-process___pt",
    path: "/pt/faq/new-user-guide/common-issues-in-the-id-verification-process/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue")
  },
  {
    name: "faq-new-user-guide-common-issues-in-the-id-verification-process___pl",
    path: "/pl/faq/new-user-guide/common-issues-in-the-id-verification-process/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/common-issues-in-the-id-verification-process/index.vue")
  },
  {
    name: "faq-privacy-and-security-are-my-funds-segregated-for-protection___en",
    path: "/en/faq/privacy-and-security/are-my-funds-segregated-for-protection/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue")
  },
  {
    name: "faq-privacy-and-security-are-my-funds-segregated-for-protection___es",
    path: "/es/faq/privacy-and-security/are-my-funds-segregated-for-protection/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue")
  },
  {
    name: "faq-privacy-and-security-are-my-funds-segregated-for-protection___it",
    path: "/it/faq/privacy-and-security/are-my-funds-segregated-for-protection/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue")
  },
  {
    name: "faq-privacy-and-security-are-my-funds-segregated-for-protection___fr",
    path: "/fr/faq/privacy-and-security/are-my-funds-segregated-for-protection/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue")
  },
  {
    name: "faq-privacy-and-security-are-my-funds-segregated-for-protection___pt",
    path: "/pt/faq/privacy-and-security/are-my-funds-segregated-for-protection/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue")
  },
  {
    name: "faq-privacy-and-security-are-my-funds-segregated-for-protection___pl",
    path: "/pl/faq/privacy-and-security/are-my-funds-segregated-for-protection/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/are-my-funds-segregated-for-protection/index.vue")
  },
  {
    name: "faq-manage-my-account-whats-the-process-for-withdrawing-my-funds___en",
    path: "/en/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue")
  },
  {
    name: "faq-manage-my-account-whats-the-process-for-withdrawing-my-funds___es",
    path: "/es/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue")
  },
  {
    name: "faq-manage-my-account-whats-the-process-for-withdrawing-my-funds___it",
    path: "/it/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue")
  },
  {
    name: "faq-manage-my-account-whats-the-process-for-withdrawing-my-funds___fr",
    path: "/fr/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue")
  },
  {
    name: "faq-manage-my-account-whats-the-process-for-withdrawing-my-funds___pt",
    path: "/pt/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue")
  },
  {
    name: "faq-manage-my-account-whats-the-process-for-withdrawing-my-funds___pl",
    path: "/pl/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/whats-the-process-for-withdrawing-my-funds/index.vue")
  },
  {
    name: "faq-new-user-guide-what-do-i-need-to-get-started-with-an-account___en",
    path: "/en/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue")
  },
  {
    name: "faq-new-user-guide-what-do-i-need-to-get-started-with-an-account___es",
    path: "/es/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue")
  },
  {
    name: "faq-new-user-guide-what-do-i-need-to-get-started-with-an-account___it",
    path: "/it/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue")
  },
  {
    name: "faq-new-user-guide-what-do-i-need-to-get-started-with-an-account___fr",
    path: "/fr/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue")
  },
  {
    name: "faq-new-user-guide-what-do-i-need-to-get-started-with-an-account___pt",
    path: "/pt/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue")
  },
  {
    name: "faq-new-user-guide-what-do-i-need-to-get-started-with-an-account___pl",
    path: "/pl/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/what-do-i-need-to-get-started-with-an-account/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-have-multiple-accounts-with-tradeview___en",
    path: "/en/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-have-multiple-accounts-with-tradeview___es",
    path: "/es/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-have-multiple-accounts-with-tradeview___it",
    path: "/it/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-have-multiple-accounts-with-tradeview___fr",
    path: "/fr/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-have-multiple-accounts-with-tradeview___pt",
    path: "/pt/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue")
  },
  {
    name: "faq-manage-my-account-can-i-have-multiple-accounts-with-tradeview___pl",
    path: "/pl/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/can-i-have-multiple-accounts-with-tradeview/index.vue")
  },
  {
    name: "faq-manage-my-account-step-by-step-instructions-for-your-deposits___en",
    path: "/en/faq/manage-my-account/step-by-step-instructions-for-your-deposits/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue")
  },
  {
    name: "faq-manage-my-account-step-by-step-instructions-for-your-deposits___es",
    path: "/es/faq/manage-my-account/step-by-step-instructions-for-your-deposits/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue")
  },
  {
    name: "faq-manage-my-account-step-by-step-instructions-for-your-deposits___it",
    path: "/it/faq/manage-my-account/step-by-step-instructions-for-your-deposits/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue")
  },
  {
    name: "faq-manage-my-account-step-by-step-instructions-for-your-deposits___fr",
    path: "/fr/faq/manage-my-account/step-by-step-instructions-for-your-deposits/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue")
  },
  {
    name: "faq-manage-my-account-step-by-step-instructions-for-your-deposits___pt",
    path: "/pt/faq/manage-my-account/step-by-step-instructions-for-your-deposits/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue")
  },
  {
    name: "faq-manage-my-account-step-by-step-instructions-for-your-deposits___pl",
    path: "/pl/faq/manage-my-account/step-by-step-instructions-for-your-deposits/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/step-by-step-instructions-for-your-deposits/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-change-or-reset-my-account-password___en",
    path: "/en/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-change-or-reset-my-account-password___es",
    path: "/es/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-change-or-reset-my-account-password___it",
    path: "/it/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-change-or-reset-my-account-password___fr",
    path: "/fr/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-change-or-reset-my-account-password___pt",
    path: "/pt/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-change-or-reset-my-account-password___pl",
    path: "/pl/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-change-or-reset-my-account-password/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-check-my-balance-and-trading-history___en",
    path: "/en/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-check-my-balance-and-trading-history___es",
    path: "/es/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-check-my-balance-and-trading-history___it",
    path: "/it/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-check-my-balance-and-trading-history___fr",
    path: "/fr/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-check-my-balance-and-trading-history___pt",
    path: "/pt/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue")
  },
  {
    name: "faq-manage-my-account-how-do-i-check-my-balance-and-trading-history___pl",
    path: "/pl/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/how-do-i-check-my-balance-and-trading-history/index.vue")
  },
  {
    name: "faq-manage-my-account-what-deposit-and-withdrawal-options-do-i-have___en",
    path: "/en/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue")
  },
  {
    name: "faq-manage-my-account-what-deposit-and-withdrawal-options-do-i-have___es",
    path: "/es/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue")
  },
  {
    name: "faq-manage-my-account-what-deposit-and-withdrawal-options-do-i-have___it",
    path: "/it/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue")
  },
  {
    name: "faq-manage-my-account-what-deposit-and-withdrawal-options-do-i-have___fr",
    path: "/fr/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue")
  },
  {
    name: "faq-manage-my-account-what-deposit-and-withdrawal-options-do-i-have___pt",
    path: "/pt/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue")
  },
  {
    name: "faq-manage-my-account-what-deposit-and-withdrawal-options-do-i-have___pl",
    path: "/pl/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/what-deposit-and-withdrawal-options-do-i-have/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-open-a-demo-account-with-tradeview-markets___en",
    path: "/en/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-open-a-demo-account-with-tradeview-markets___es",
    path: "/es/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-open-a-demo-account-with-tradeview-markets___it",
    path: "/it/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-open-a-demo-account-with-tradeview-markets___fr",
    path: "/fr/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-open-a-demo-account-with-tradeview-markets___pt",
    path: "/pt/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-can-i-open-a-demo-account-with-tradeview-markets___pl",
    path: "/pl/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/can-i-open-a-demo-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-which-markets-can-i-trade-with-tradeview-markets___en",
    path: "/en/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-which-markets-can-i-trade-with-tradeview-markets___es",
    path: "/es/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-which-markets-can-i-trade-with-tradeview-markets___it",
    path: "/it/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-which-markets-can-i-trade-with-tradeview-markets___fr",
    path: "/fr/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-which-markets-can-i-trade-with-tradeview-markets___pt",
    path: "/pt/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-which-markets-can-i-trade-with-tradeview-markets___pl",
    path: "/pl/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/which-markets-can-i-trade-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-do-i-set-up-two-factor-authentication-2fa___en",
    path: "/en/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-do-i-set-up-two-factor-authentication-2fa___es",
    path: "/es/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-do-i-set-up-two-factor-authentication-2fa___it",
    path: "/it/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-do-i-set-up-two-factor-authentication-2fa___fr",
    path: "/fr/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-do-i-set-up-two-factor-authentication-2fa___pt",
    path: "/pt/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-do-i-set-up-two-factor-authentication-2fa___pl",
    path: "/pl/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-do-i-set-up-two-factor-authentication-2fa/index.vue")
  },
  {
    name: "faq-fees-and-platforms-which-trading-platforms-can-i-use-with-tradeview___en",
    path: "/en/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue")
  },
  {
    name: "faq-fees-and-platforms-which-trading-platforms-can-i-use-with-tradeview___es",
    path: "/es/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue")
  },
  {
    name: "faq-fees-and-platforms-which-trading-platforms-can-i-use-with-tradeview___it",
    path: "/it/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue")
  },
  {
    name: "faq-fees-and-platforms-which-trading-platforms-can-i-use-with-tradeview___fr",
    path: "/fr/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue")
  },
  {
    name: "faq-fees-and-platforms-which-trading-platforms-can-i-use-with-tradeview___pt",
    path: "/pt/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue")
  },
  {
    name: "faq-fees-and-platforms-which-trading-platforms-can-i-use-with-tradeview___pl",
    path: "/pl/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/which-trading-platforms-can-i-use-with-tradeview/index.vue")
  },
  {
    name: "faq-new-user-guide-how-can-i-open-a-live-account-with-tradeview-markets___en",
    path: "/en/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-how-can-i-open-a-live-account-with-tradeview-markets___es",
    path: "/es/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-how-can-i-open-a-live-account-with-tradeview-markets___it",
    path: "/it/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-how-can-i-open-a-live-account-with-tradeview-markets___fr",
    path: "/fr/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-how-can-i-open-a-live-account-with-tradeview-markets___pt",
    path: "/pt/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-how-can-i-open-a-live-account-with-tradeview-markets___pl",
    path: "/pl/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/how-can-i-open-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-manage-my-account-i-already-have-a-cabinet-how-do-i-open-a-new-account___en",
    path: "/en/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue")
  },
  {
    name: "faq-manage-my-account-i-already-have-a-cabinet-how-do-i-open-a-new-account___es",
    path: "/es/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue")
  },
  {
    name: "faq-manage-my-account-i-already-have-a-cabinet-how-do-i-open-a-new-account___it",
    path: "/it/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue")
  },
  {
    name: "faq-manage-my-account-i-already-have-a-cabinet-how-do-i-open-a-new-account___fr",
    path: "/fr/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue")
  },
  {
    name: "faq-manage-my-account-i-already-have-a-cabinet-how-do-i-open-a-new-account___pt",
    path: "/pt/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue")
  },
  {
    name: "faq-manage-my-account-i-already-have-a-cabinet-how-do-i-open-a-new-account___pl",
    path: "/pl/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/manage-my-account/i-already-have-a-cabinet-how-do-i-open-a-new-account/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-is-my-personal-and-financial-information-protected___en",
    path: "/en/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-is-my-personal-and-financial-information-protected___es",
    path: "/es/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-is-my-personal-and-financial-information-protected___it",
    path: "/it/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-is-my-personal-and-financial-information-protected___fr",
    path: "/fr/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-is-my-personal-and-financial-information-protected___pt",
    path: "/pt/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue")
  },
  {
    name: "faq-privacy-and-security-how-is-my-personal-and-financial-information-protected___pl",
    path: "/pl/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/privacy-and-security/how-is-my-personal-and-financial-information-protected/index.vue")
  },
  {
    name: "faq-account-features-what-stock-exchanges-are-available-for-trading-at-tradeview___en",
    path: "/en/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue")
  },
  {
    name: "faq-account-features-what-stock-exchanges-are-available-for-trading-at-tradeview___es",
    path: "/es/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue")
  },
  {
    name: "faq-account-features-what-stock-exchanges-are-available-for-trading-at-tradeview___it",
    path: "/it/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue")
  },
  {
    name: "faq-account-features-what-stock-exchanges-are-available-for-trading-at-tradeview___fr",
    path: "/fr/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue")
  },
  {
    name: "faq-account-features-what-stock-exchanges-are-available-for-trading-at-tradeview___pt",
    path: "/pt/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue")
  },
  {
    name: "faq-account-features-what-stock-exchanges-are-available-for-trading-at-tradeview___pl",
    path: "/pl/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-stock-exchanges-are-available-for-trading-at-tradeview/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay-in-the-stocks-market___en",
    path: "/en/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay-in-the-stocks-market___es",
    path: "/es/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay-in-the-stocks-market___it",
    path: "/it/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay-in-the-stocks-market___fr",
    path: "/fr/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay-in-the-stocks-market___pt",
    path: "/pt/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue")
  },
  {
    name: "faq-fees-and-platforms-what-fees-and-commissions-will-i-pay-in-the-stocks-market___pl",
    path: "/pl/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/fees-and-platforms/what-fees-and-commissions-will-i-pay-in-the-stocks-market/index.vue")
  },
  {
    name: "faq-new-user-guide-step-by-step-guide-to-opening-a-live-account-with-tradeview-markets___en",
    path: "/en/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-step-by-step-guide-to-opening-a-live-account-with-tradeview-markets___es",
    path: "/es/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-step-by-step-guide-to-opening-a-live-account-with-tradeview-markets___it",
    path: "/it/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-step-by-step-guide-to-opening-a-live-account-with-tradeview-markets___fr",
    path: "/fr/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-step-by-step-guide-to-opening-a-live-account-with-tradeview-markets___pt",
    path: "/pt/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-new-user-guide-step-by-step-guide-to-opening-a-live-account-with-tradeview-markets___pl",
    path: "/pl/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/index.vue")
  },
  {
    name: "faq-account-features-what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics___en",
    path: "/en/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue")
  },
  {
    name: "faq-account-features-what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics___es",
    path: "/es/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue")
  },
  {
    name: "faq-account-features-what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics___it",
    path: "/it/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue")
  },
  {
    name: "faq-account-features-what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics___fr",
    path: "/fr/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue")
  },
  {
    name: "faq-account-features-what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics___pt",
    path: "/pt/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue")
  },
  {
    name: "faq-account-features-what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics___pl",
    path: "/pl/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/",
    component: () => import("/codebuild/output/src3564164168/src/TVEUROPE-landing/pages/faq/account-features/what-type-of-accounts-are-available-for-forex-trading-and-what-are-their-characteristics/index.vue")
  },
  {
    name: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta?.name,
    path: "/en/sitemap.xml/",
    component: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64
  },
  {
    name: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta?.name,
    path: "/es/sitemap.xml/",
    component: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64
  },
  {
    name: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta?.name,
    path: "/it/sitemap.xml/",
    component: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64
  },
  {
    name: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta?.name,
    path: "/fr/sitemap.xml/",
    component: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64
  },
  {
    name: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta?.name,
    path: "/pt/sitemap.xml/",
    component: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64
  },
  {
    name: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64Meta?.name,
    path: "/pl/sitemap.xml/",
    component: component_45stub2wQKCbgAvVKF0QZg_4gBfC6Tv2oRoJZIERzNiEImH64
  }
]